<template>
    <div>
        <el-dialog title="导入Excel" :visible.sync="uploadExcelVisible" width="40%" :before-close="handleClose">
            <el-upload
                class="upload-demo"
                action="#"
                :limit="1"
                :before-upload="beforeAvatarUpload"
                :http-request="upload"
                :show-file-list="true"
                :file-list="fileList"
            >
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose">取 消</el-button>
                <el-button type="primary" @click="define">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import { importDate } from '@/utils/request.js';

export default {
    props: {
        uploadExcelVisible: {
            type: Boolean,
            default: false
        },
        importUrl: {
            type: String,
            default: ''
        }
    },

    data() {
        return {
            formData: null,
            fileList: []
        };
    },

    watch: {
        uploadExcelVisible: {
            handler(newVal, oldVal) {
                this.fileList = [];
            },
            deep: true
        }
    },

    methods: {
        handleClose() {
            this.$emit('cancel', false);
        },
        beforeAvatarUpload(file) {
            if (
                ['application/vnd.ms-powerpoint', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'].indexOf(file.type) ==
                -1
            ) {
                this.$message.error('请上传正确类型的文件格式');
                return false;
            }
        },
        upload(params) {
            const file = params.file;
            this.formData = new FormData();
            this.formData.append('file', file);
        },
        define() {
            importDate(this.importUrl, this.formData).then((res) => {
                this.$emit('finish', res);
            });
        }
    }
};
</script>
<style lang="scss" scoped>
::v-deep .el-dialog__body {
    padding: 20px !important;
}
::v-deep .el-upload--text {
    width: auto;
    height: auto;
    border: 0;
}
</style>
